export const plansRoute = '/plans';
